module.exports = __webpack_public_path__ + "static/media/informeusodesuelo.3e8052d1.png";